<template>

  <div class="home">

    <div class="warning">
      <img src="../assets/warning_webshop.svg">  
    </div>
  	<div class="wrapper">
      {{errorResponse.message}}
    </div>
  </div>

</template>

<script>
export default {
  name: 'Error',
  props: {
    email: String
  },
  data : function(){       
    return {
      
    }
  },
  computed: {
      errorResponse(){
          return this.$store.getters.getErrorResponse;
      }
  },
  created : function(){

   


  },
  
  methods:{

    
  }
}
</script>

